import * as fromRoot from '../root-actions';

export interface RootState {
    isUserLogged: boolean;
    toRememberUser: boolean;
    appLanguage: string;
}

export const initialState: RootState = {
    isUserLogged: false,
    toRememberUser: false,
    appLanguage: 'heb'
};

export function rootReducer(
    state = initialState,
    action: fromRoot.RootAction,
): RootState {
    switch (action.type) {
        case fromRoot.ROOT_LOGIN_USER_SUCCESS: {
            return {
                ...state,
                isUserLogged: true,
            };
        }
        case fromRoot.ROOT_LOGIN_USER_FAIL: {
            return {
                ...state,
                isUserLogged: false,
            };
        }
        case fromRoot.ROOT_LOGOUT_USER: {
            return {
                ...state,
            };
        }
        case fromRoot.ROOT_LOGOUT_USER_SUCCESS: {
            return {
                ...state,
                isUserLogged: false,
            };
        }
        case fromRoot.ROOT_LOGOUT_USER_FAIL: {
            return {
                ...state,
                isUserLogged: true,
            };
        }
        case fromRoot.ROOT_REMEMBER_USER: {
            return {
                ...state,
                toRememberUser: true
            };
        }
        case fromRoot.ROOT_SET_LANGUAGE: {
            return {
                ...state,
                appLanguage: action.payload
            };
        }
        default:
            return state;
    }
}

export const getRoot = (state: any) => state;
export const getRootIsLogged = (state: any) => state.root.isUserLogged;
export const getRootToRemember = (state: any) => state.root.toRememberUser;
export const getCurrentLanguage = (state: any) => state.root.appLanguage;
